// eslint-disable-next-line
import { NameSpacing } from '../../../NonReact/utils/NameSpacing'

export const GENERAL = 'general'
export const SCOPE_ASSIGNMENTS = 'scopeAssignment'

export enum GeneralTabFieldNames {
    GUID = 'guid',
    CODE = 'code',
    CODE_TYPE = 'codeType',
    DESCRIPTION = 'description',
    UPDATE_EXISTING = 'updateExisting'
}

export enum ScopeAssignmentTabFieldNames {
    CME = 'cme',
    FILTER_RECURSIVELY = 'filterRecursively',
    TELEPHONY_SERVER = 'telephonyServer',
    PARTITION = 'partition'
}

export const CodeGeneralNameSpacing: (fieldName: string) => string = (fieldName: string): string =>
    NameSpacing(GENERAL, fieldName)

export const ScopeAssignmentNameSpacing: (fieldName: string) => string = (fieldName: string): string =>
    NameSpacing(SCOPE_ASSIGNMENTS, fieldName)

export const GUID_GENERAL_NAME: string = CodeGeneralNameSpacing(GeneralTabFieldNames.GUID)
export const CODE_GENERAL_NAME: string = CodeGeneralNameSpacing(GeneralTabFieldNames.CODE)
export const CODE_TYPE_GENERAL_NAME: string = CodeGeneralNameSpacing(GeneralTabFieldNames.CODE_TYPE)
export const DESCRIPTION_GENERAL_NAME: string = CodeGeneralNameSpacing(GeneralTabFieldNames.DESCRIPTION)
export const UPDATE_EXISTING_GENERAL_NAME: string = CodeGeneralNameSpacing(GeneralTabFieldNames.UPDATE_EXISTING)

export const CME_SCOPE_NAME: string = ScopeAssignmentNameSpacing(ScopeAssignmentTabFieldNames.CME)
export const FILTER_RECURSIVELY_SCOPE_NAME: string = ScopeAssignmentNameSpacing(
    ScopeAssignmentTabFieldNames.FILTER_RECURSIVELY
)
export const TELEPHONY_SERVER_SCOPE_NAME: string = ScopeAssignmentNameSpacing(
    ScopeAssignmentTabFieldNames.TELEPHONY_SERVER
)
export const PARTITION_SCOPE_NAME: string = ScopeAssignmentNameSpacing(ScopeAssignmentTabFieldNames.PARTITION)
